export const colors = {
  green: {
    '50': '#E9F9E9',
    '100': '#DEF5DE',
    '200': '#BAEBBB',
    '300': '#21BF25',
    '400': '#1EAC21',
    '500': '#1A991E',
    '600': '#198F1C',
    '700': '#147316',
    '800': '#0F5611',
    '900': '#0C430D',
  },
  red: {
    '50': '#FDEBEA',
    '100': '#FCE1DF',
    '200': '#F9C2BD',
    '300': '#ED3A2A',
    '400': '#D53426',
    '500': '#BE2E22',
    '600': '#B22C20',
    '700': '#8E2319',
    '800': '#6B1A13',
    '900': '#53140F',
  },
  orange: {
    '50': '#FEF1E8',
    '100': '#FEEADC',
    '200': '#FDD3B7',
    '300': '#F97216',
    '400': '#E06714',
    '500': '#C75B12',
    '600': '#BB5611',
    '700': '#95440D',
    '800': '#70330A',
    '900': '#572808',
  },
  blue: {
    '50': '#E9F3FF',
    '100': '#DEEDFF',
    '200': '#BCD9FF',
    '300': '#2684FF',
    '400': '#2277E6',
    '500': '#1E6ACC',
    '600': '#1D63BF',
    '700': '#174F99',
    '800': '#113B73',
    '900': '#0D2E59',
  },
  yellow: {
    '50': '#FFF9E6',
    '100': '#FFF6DA',
    '200': '#FFECB2',
    '300': '#FFC107',
    '400': '#E6AE06',
    '500': '#CC9A06',
    '600': '#BF9105',
    '700': '#997404',
    '800': '#735703',
    '900': '#594402',
  },
  purple: {
    '50': '#F6ECFE',
    '100': '#F1E3FD',
    '200': '#E2C4FC',
    '300': '#A041F4',
    '400': '#903BDC',
    '500': '#8034C3',
    '600': '#7831B7',
    '700': '#602792',
    '800': '#481D6E',
    '900': '#381755',
  },
  pink: {
    '50': '#FEECF5',
    '100': '#FDE3F0',
    '200': '#FCC4E1',
    '300': '#F4419D',
    '400': '#DC3B8D',
    '500': '#C3347E',
    '600': '#B73176',
    '700': '#92275E',
    '800': '#6E1D47',
    '900': '#551737',
  },
  gray: {
    '50': '#F0F0F0',
    '100': '#E8E8E8',
    '200': '#D0D0D0',
    '300': '#666666',
    '400': '#5C5C5C',
    '500': '#525252',
    '600': '#4D4D4D',
    '700': '#3D3D3D',
    '800': '#2E2E2E',
    '900': '#242424',
  },
  white: '#FFFFFF',
  black: '#000000',
} as const;

export const semanticColors = {
  success: colors.green['400'],
  error: colors.red['300'],
  warning: colors.yellow['400'],
  payments: '#D75F48',
  charge: '#3C86C9',
  border: colors.gray['100'],

  // Button colors
  buttons: {
    primary: colors.green['400'],
    secondary: colors.gray['100'],
    tertiary: colors.gray['300'],
  },

  // Text colors
  text: {
    primary: colors.gray['400'],
    secondary: '#757575',
    onButton: colors.white,
    link: colors.green['400'],
    linkHover: colors.green['600'],
    positive: colors.green['600'],
    error: colors.red['600'],
  },

  // Accent colors
  accent: {
    green: colors.green['300'],
    red: colors.red['300'],
    blue: colors.blue['300'],
    yellow: colors.yellow['300'],
    purple: colors.purple['300'],
    pink: colors.pink['300'],
  },
} as const;

export type Colors = typeof colors;
export type SemanticColors = typeof semanticColors;

export type ColorKey = keyof Colors;
// since white and black don't have gradients, we exclude them
export type GradientKey = keyof Colors[Exclude<ColorKey, 'white' | 'black'>];
